// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--GjquL","promo":"a10a3f92e9--promo--Bk46n","icon":"a10a3f92e9--icon--Z9aBM"};